/**
 * Helper function to deep merge two complex objects.
 * Uses recursion to drill down to the value-type properties of nested objects or arrays.
 * Returns a new merged object without changing the original.
 * Does not remove properties from the object being updated, will add new ones (if present in update object).
 * @param original Object to update
 * @param update Object with new values (and properties)
 * @return Merged object
 */
export function deepMerge(original, update) {
    var deepClone = JSON.parse(JSON.stringify(original));
    merge(deepClone, update);
    return deepClone;
}
function merge(objToUpdate, newObject) {
    if (newObject === null || newObject === undefined) {
        return;
    }
    // will skip empty objects and arrays
    Object.keys(newObject).forEach(function (prop) {
        if (typeof newObject[prop] === "object" && objToUpdate.hasOwnProperty(prop) && objToUpdate[prop] != undefined) {
            merge(objToUpdate[prop], newObject[prop]);
        }
        else {
            objToUpdate[prop] = newObject[prop];
        }
    });
}
//# sourceMappingURL=DeepMerge.js.map